import secureLocalStorage from "react-secure-storage";
import { io } from "socket.io-client";

const getUserToken = () => {
  let user = JSON.parse(secureLocalStorage.getItem("user"));
  let formatedToken = null;
  if (user) formatedToken = `Bearer ${user.token}`;
  return formatedToken;
};

export const statsSocket = io(`${process.env.REACT_APP_SOCKET_ROUTE}/stats`, {
  reconnectionAttempts: 5,
  transports: ["websocket"],
  path: "/ws",
  autoConnect: false,
  auth: { authorization: getUserToken() },
  // forceNew: true, // force new otherwise all the sockets share the same query
});

export const expariencesSocket = io(
  `${process.env.REACT_APP_SOCKET_ROUTE}/expariences`,
  {
    reconnectionAttempts: 5,
    transports: ["websocket"],
    path: "/ws",
    autoConnect: false,
    auth: { authorization: getUserToken() },
    // forceNew: true, // force new otherwise all the sockets share the same query
  }
);

export const webChatSocket = io(
  `${process.env.REACT_APP_SOCKET_ROUTE}/public/chat`,
  {
    reconnectionAttempts: 5,
    transports: ["websocket"],
    path: "/ws",
    autoConnect: false,
  }
);
